import { type RepositoryAuthor } from "@prismicio/editor-fields"

import type { Filter, FilterType } from "./useActionBar"

export function getFilterType(filters: Filter[], filterType: FilterType) {
  return filters.filter((filter) => filter.type === filterType)
}

export function getAuthorDisplayName(author: RepositoryAuthor) {
  const { firstname, lastname } = author

  // If both firstname and lastname are empty, return the author id
  if (!firstname && !lastname) return author.id

  // If one of the firstname or lastname is empty, return the other
  if (!firstname && lastname) return lastname
  if (!lastname && firstname) return firstname

  // If both firstname and lastname are not empty, return the full name
  if (firstname && lastname) return `${firstname} ${lastname}`

  return ""
}
